import api from '@/lib/api';

export const WEB_SCRAPER_STAGES = [
  { key: 'search', label: 'Search web', description: 'Discover webpage URLs' },
  { key: 'fetch', label: 'Fetch HTML', description: 'Download pages to S3' },
  { key: 'parse', label: 'Parse HTML', description: 'Extract image candidates' },
  { key: 'images', label: 'Process images', description: 'Download images to S3' },
];

export function normalizeWebScraperSteps(payload) {
  const steps = Array.isArray(payload?.steps) ? payload.steps : [];
  if (steps.length) return steps;
  const stages = payload?.stages || {};
  return WEB_SCRAPER_STAGES.map(({ key, label, description }) => {
    const st = stages[key] || {};
    const current = Number(st.current) || 0;
    const total = Number(st.total) || 0;
    const status = String(st.status || 'PENDING').toUpperCase();
    const progressPercent = total > 0
      ? Math.round((100 * current) / total)
      : (status === 'COMPLETED' ? 100 : 0);
    return { key, label, description, status, current, total, progressPercent };
  });
}

export async function fetchWebScraperJob(jobId) {
  if (!jobId) return null;
  const { data } = await api.get(`/image-search/${jobId}`);
  return data;
}

export async function fetchWebScraperJobForProject(projectId) {
  if (!projectId) return null;
  const { data } = await api.get(`/image-search/by-project/${projectId}`);
  return data;
}

export function webScraperActiveFromGenerationJob(job) {
  const snap = job?.asset_search_progress;
  if (snap?.steps?.length) {
    return {
      jobId: snap.jobId || job?.asset_search_job_id,
      status: snap.status,
      steps: snap.steps,
      errors: snap.errors || [],
      message: job?.message,
    };
  }
  if (job?.asset_search_job_id) {
    return {
      jobId: job.asset_search_job_id,
      status: job.status,
      steps: [],
      errors: [],
      message: job?.message,
    };
  }
  return null;
}

export function isWebScraperPipelineMessage(message) {
  return String(message || '').toLowerCase().includes('web scraper');
}
